module.exports = __webpack_public_path__ + "img/buscador_imagen.2984ae67.png";